import { CPP_EST_RECEIVED, CPP_EST_UNLOADED, CPP_RESULT_RECEIVED } from './types'

export default function cppestimator(state = {}, action = {}){
  switch (action.type) {
    case CPP_EST_RECEIVED:
      return {
        ...state,
        data: action.data
      }
    case CPP_RESULT_RECEIVED:
      return {
        ...state,
        results: action.results
      }
    case CPP_EST_UNLOADED:
      return {}
    default:
      return state;
  }
}
